/**
 * HM-072 — Toast host minimale (no extra deps).
 * Le notifiche sono gestite via useDashboardLiveSync.
 */

export type ToastEntry = {
  id: string;
  text: string;
  level: 'info' | 'success' | 'warning' | 'error';
};

export type ToastHostProps = {
  toasts: ToastEntry[];
  onDismiss: (id: string) => void;
};

const COLORS: Record<ToastEntry['level'], { bg: string; fg: string }> = {
  info: { bg: '#1e293b', fg: '#fff' },
  success: { bg: '#16a34a', fg: '#fff' },
  warning: { bg: '#eab308', fg: '#0f172a' },
  error: { bg: '#dc2626', fg: '#fff' },
};

export function ToastHost({ toasts, onDismiss }: ToastHostProps) {
  return (
    <div
      data-testid="toast-host"
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        zIndex: 9999,
      }}
    >
      {toasts.map((t) => {
        const c = COLORS[t.level];
        return (
          <div
            key={t.id}
            // biome-ignore lint/a11y/useSemanticElements: role=status su live region notifica.
            // biome-ignore lint/a11y/useKeyWithClickEvents: keyDown handler gia' presente.
            role="status"
            data-testid={`toast-${t.level}`}
            style={{
              background: c.bg,
              color: c.fg,
              padding: '8px 12px',
              borderRadius: 6,
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
              fontSize: 13,
              minWidth: 200,
              cursor: 'pointer',
            }}
            onClick={() => onDismiss(t.id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') onDismiss(t.id);
            }}
          >
            {t.text}
          </div>
        );
      })}
    </div>
  );
}
